import INVENTORY_API_BASE_URL from "../../config/api";






import React, { useEffect, useState } from "react";
import axios from "axios";
import "./manageshipments.css";

function Manageshipments() {
  const [shipments, setShipments] = useState([]);
  const [approveDPO, setApproveDPO] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const shipmentsRes = await axios.get(
          `${INVENTORY_API_BASE_URL}/get-shipments`
        );
        const approveDPORes = await axios.get(
          `${INVENTORY_API_BASE_URL}/getApproveDPO`
        );
        setShipments(shipmentsRes.data);
        setApproveDPO(approveDPORes.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const getDistributorName = (orderNum) => {
    const match = approveDPO.find((item) => item.shipmentid === orderNum);
    return match ? match.distributorName : "N/A";
  };

  const totalShipmentCount = shipments.length;
  const totalBarcodeCount = shipments.reduce(
    (total, shipment) => total + Number(shipment.totalCount || 0),
    0
  );
  const totalBoxCount = shipments.reduce(
    (total, shipment) => total + Number(shipment.totalBoxes || 0),
    0
  );

  return (
    <main className="manageshipments-container manageshipments-page">
      <header className="manage-shipments-hero">
        <div>
          <p className="manage-shipments-eyebrow">Outbound · Dispatch history</p>
          <h1>Manage Shipments</h1>
          <p>Review completed shipments, box totals, and the order details recorded for each dispatch.</p>
        </div>
        <div className="manage-shipments-hero__badge">
          <span className="manage-shipments-hero__icon" aria-hidden="true">OUT</span>
          <span>
            <strong>Shipment records</strong>
            <small>Outbound operations</small>
          </span>
        </div>
      </header>

      <section className="manage-shipments-metrics" aria-label="Shipment totals">
        <article className="manage-shipments-metric">
          <span className="manage-shipments-metric__icon" aria-hidden="true">BCH</span>
          <span className="manage-shipments-metric__copy">
            <span>Shipment batches</span>
            <strong>{loading ? "—" : totalShipmentCount.toLocaleString()}</strong>
          </span>
        </article>
        <article className="manage-shipments-metric manage-shipments-metric--barcodes">
          <span className="manage-shipments-metric__icon" aria-hidden="true">SKU</span>
          <span className="manage-shipments-metric__copy">
            <span>Total barcode count</span>
            <strong>{loading ? "—" : totalBarcodeCount.toLocaleString()}</strong>
          </span>
        </article>
        <article className="manage-shipments-metric manage-shipments-metric--boxes">
          <span className="manage-shipments-metric__icon" aria-hidden="true">BOX</span>
          <span className="manage-shipments-metric__copy">
            <span>Total boxes</span>
            <strong>{loading ? "—" : totalBoxCount.toLocaleString()}</strong>
          </span>
        </article>
      </section>

      <section className="manage-shipments-panel" aria-labelledby="shipment-history-heading">
        <div className="manage-shipments-panel__heading">
          <div>
            <p className="manage-shipments-eyebrow">Shipment register</p>
            <h2 id="shipment-history-heading">Shipment history</h2>
            <p>Box-level order and distributor information for every recorded shipment.</p>
          </div>
          {!loading && (
            <span className="manage-shipments-record-count">
              {totalShipmentCount.toLocaleString()} {totalShipmentCount === 1 ? "shipment" : "shipments"}
            </span>
          )}
        </div>

        {loading ? (
          <div className="manage-shipments-loading" role="status" aria-live="polite">
            <span className="manage-shipments-spinner" aria-hidden="true" />
            <strong>Loading shipment history</strong>
            <span>Retrieving the latest outbound records…</span>
          </div>
        ) : shipments.length > 0 ? (
          <div className="manage-shipments-table-wrap">
            <table className="manage-shipments-table">
              <thead>
                <tr>
                  <th scope="col">Total count</th>
                  <th scope="col">Total boxes</th>
                  <th scope="col">Date</th>
                  <th scope="col">Shipment details</th>
                </tr>
              </thead>
              <tbody>
                {shipments.map((shipment, index) => (
                  <tr key={shipment._id || index}>
                    <td data-label="Total count">
                      <span className="manage-shipments-total">{shipment.totalCount}</span>
                    </td>
                    <td data-label="Total boxes">
                      <span className="manage-shipments-box-total">
                        <span aria-hidden="true">▣</span>
                        {shipment.totalBoxes}
                      </span>
                    </td>
                    <td className="manage-shipments-date" data-label="Date">
                      {new Date(shipment.date).toLocaleDateString("en-GB")}
                    </td>
                    <td data-label="Shipment details">
                      <div className="manage-shipments-details">
                        {shipment.barcodeData.map((barcode, barcodeIndex) => (
                          <article className="manage-shipments-box-card" key={barcode.BoxNo || barcodeIndex}>
                            <div className="manage-shipments-box-card__heading">
                              <span className="manage-shipments-box-number">
                                <span aria-hidden="true">▣</span> Box {barcode.BoxNo}
                              </span>
                              <span className="manage-shipments-box-count">
                                {barcode.count} {barcode.count === 1 ? "item" : "items"}
                              </span>
                            </div>
                            <dl className="manage-shipments-box-meta">
                              <div>
                                <dt>Order number</dt>
                                <dd>{barcode.OrderNum}</dd>
                              </div>
                              <div>
                                <dt>Distributor</dt>
                                <dd>{getDistributorName(barcode.OrderNum)}</dd>
                              </div>
                            </dl>
                          </article>
                        ))}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="manage-shipments-empty">
            <span className="manage-shipments-empty__icon" aria-hidden="true">OUT</span>
            <strong>No shipments to display</strong>
            <span>Completed outbound shipments will appear here.</span>
          </div>
        )}
      </section>
    </main>
  );
}

export default Manageshipments;
